import React, { useState } from "react";
import { FormatValueDecimal, CurrencyConvertion } from '../../utils/Validate';
import { NotFound } from '../../components/common/NotFound';
import Avatar from "../../components/common/Avatar";
import PaginationComponent from '../common/PaginationComponent';
import SkeletonQuotationListing from '../common/skeletonQuotationListing';

// ---- Customer Order Status / Color Code helper -----------------------------
// Fully Released     -> entire quotation released -> light green
// Partially Released -> only part of the quotation released -> light orange
// No Release         -> nothing released yet -> white
// Cancelled          -> cancelStatus true -> light gray
const getReleaseStatus = (item) => {
    if (item?.orderStatus === 3) {
        return { label: "Cancelled", className: "status-cancelled" };
    }

    const orderedQty = item?.currentOrderQuantity || 0;
    const releasedQty = item?.factoryReleasedQuantity || 0;

    if (releasedQty <= 0) {
        return { label: "No Release", className: "status-none" };
    }

    if (releasedQty >= orderedQty) {
        return { label: "Fully Released", className: "status-full" };
    }

    return { label: "Partially Released", className: "status-partial" };
};

const OrderGrid = (props) => {
    const { menuRights, handleDelete, handleView, handleEdit, assignedEngineerList, loading, orderList, filterData, setPageNumber, setPageSize, pageSize, distributorData, projectData, countryData, customerData, currencyData } = props;
    return (<>
        {orderList?.payload?.length > 0 ?
            <div className="row order-table-row row-height mb-1">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="card mt-0 order-list-card">
                        <div className="card-body">
                            <div className="table-responsive order-table-responsive">
                                <table className="table table-borderless table-list order-table-list">
                                    <thead>
                                        <tr>
                                            <th><div>PROJECT</div></th>
                                            <th><div>CUSTOMER ORDER REF</div></th>
                                            <th><div>CUSTOMER</div></th>
                                            <th><div>DISTRIBUTOR</div></th>
                                            <th><div>COUNTRY</div></th>
                                            <th className="text-right"><div>ORDER VALUE</div></th>
                                            <th><div>ACTIONS</div></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderList?.payload.map((item, index) => {
                                            const projectDetails = projectData?.find(project => project.id === item.projectId);
                                            const distributorDetails = distributorData?.find(distributor => distributor.id === item.distributorId);
                                            const countryDetails = countryData?.find(country => country.id === item.countryId);
                                            const customerDetails = customerData?.find(customer => customer.id === item.customerId);
                                            const currencyDetails = currencyData?.find(currency => currency.id === item.currencyId);
                                            const assignedEngineerDetails = assignedEngineerList?.find(engineer => engineer.identityId === item.salesEngineerId);
                                            const handleProjectEdit = menuRights?.canEdit === true
                                                ? () => handleEdit(item)
                                                : menuRights?.canView === true
                                                    ? () => handleView(item, projectDetails, distributorDetails, countryDetails, customerDetails, currencyDetails, assignedEngineerDetails)
                                                    : undefined;
                                            const releaseStatus = getReleaseStatus(item);


                                            return (
                                                <tr key={item?.id || index} className={`order-status-row ${releaseStatus.className}`}>
                                                    <td
                                                        onClick={handleProjectEdit}
                                                        className={menuRights?.canEdit === true || menuRights?.canView === true ? "clickable-cell" : ""}
                                                    >
                                                        <div className="project-cell">
                                                            <Avatar preName={projectDetails?.projectName} />
                                                            <h5 title={projectDetails?.projectName}>{projectDetails?.projectName || "-"}</h5>
                                                        </div>
                                                    </td>
                                                    <td><h5 title={item?.orderReference}>{item?.orderReference || "-"}</h5></td>
                                                    <td><h5 title={customerDetails?.customerName}>{customerDetails?.customerName || "-"}</h5></td>
                                                    <td><h5 title={distributorDetails?.distributorName}>{distributorDetails?.distributorName || "-"}</h5></td>
                                                    <td><h5 title={countryDetails?.name}>{countryDetails?.name || "-"}</h5></td>
                                                    <td className="text-right">
                                                        {item?.grandTotal ? (
                                                            <h5 title={currencyDetails?.shortCode}>
                                                                {currencyDetails?.shortCode || "-"}{" "}
                                                                {FormatValueDecimal(
                                                                    CurrencyConvertion(item.grandTotal, item?.conversionRate, currencyDetails)
                                                                )}
                                                            </h5>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-center align-items-baseline">
                                                            <div class="dropdown dropleft text-center action-menu">
                                                                <i
                                                                    class="fas fa-ellipsis-v"
                                                                    id="dropdownMenuButton"
                                                                    data-toggle="dropdown"
                                                                    aria-haspopup="false"
                                                                    aria-expanded="false"
                                                                ></i>
                                                                <div
                                                                    class="dropdown-menu p-0"
                                                                    aria-labelledby="dropdownMenuButton"
                                                                >
                                                                    <ul>
                                                                        {menuRights?.canEdit === true && <li onClick={() => handleEdit(item)}>
                                                                            <span>
                                                                                <i class="far fa-edit"></i> Edit
                                                                            </span>
                                                                        </li>}
                                                                        {menuRights?.canDelete === true && <li onClick={() => handleDelete(item)}>
                                                                            <span>
                                                                                <i class="far fa-trash-alt mr-1"></i> Delete
                                                                            </span>
                                                                        </li>}
                                                                        {menuRights?.canView === true &&
                                                                            <li>
                                                                                <span title="View" onClick={() => handleView(item, projectDetails, distributorDetails, countryDetails, customerDetails, currencyDetails, assignedEngineerDetails)}>
                                                                                    <i className="fa fa-eye"></i> View
                                                                                </span>
                                                                            </li>}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            : loading === true ? <>
                <SkeletonQuotationListing rows={12} />
            </> : <NotFound />}

        {orderList?.totalRecords > 0 && (
            <PaginationComponent
                moduleName="Order"
                count={pageSize}
                setCount={setPageSize}
                pageSize={filterData?.PageSize}
                currentPage={filterData?.PageNumber}
                filteredResults={orderList}
                setCurrentPage={setPageNumber} />)}

    </>
    )
}

export default OrderGrid